
export enum TriggerActionTypeEnum {
  EMAIL_ACTION = "EMAIL_ACTION",
  WEBHOOK_ACTION = "WEBHOOK_ACTION",
  TELEGRAM_ACTION = "TELEGRAM_ACTION",
  TEAMS_ACTION = "TEAMS_ACTION",
}

export const ALARM_ACTION_TYPE = [
  {value: TriggerActionTypeEnum.EMAIL_ACTION, title: 'Email'},
  {value: TriggerActionTypeEnum.WEBHOOK_ACTION, title: 'Webhook'},
  {value: TriggerActionTypeEnum.TELEGRAM_ACTION, title: 'Telegram'},
  {value: TriggerActionTypeEnum.TEAMS_ACTION, title: 'Teams'},
]

export enum TriggerActionWebhookTypeEnum {
  DELETE = "DELETE",
  PUT = "PUT",
  POST = "POST",
  GET = "GET",
  PATCH = "PATCH",
}

export interface TriggerEmailEventContentDTO {
  emailTo: string;
  emailFrom?: string;
  emailReplyTo?: string;
  emailBcc?: string;
  subject: string;
  template: string;
  xdays: string;
}

export interface TriggerEmailAction {
  type: TriggerActionTypeEnum.EMAIL_ACTION;
  stateful: false;
  emailConfig: TriggerEmailEventContentDTO;
  actionId?: string;
  enabled?: boolean;
}

export interface TriggerWebhookEventContentDTO {
  headers: {};
  method: string;
  url: string;
  template: string;
  xdays: string;
}

export interface TriggerWebhookAction {
  type: TriggerActionTypeEnum.WEBHOOK_ACTION;
  stateful: false;
  webhookConfig: TriggerWebhookEventContentDTO;
  actionId?: string;
  enabled?: boolean;
}

export class TriggerTelegramEventContentDTO {
  token: string;
  chatId: string;
  template: string;
  xdays: string;
}

export interface TriggerTelegramAction {
  type: TriggerActionTypeEnum.TELEGRAM_ACTION;
  stateful: false;
  telegramConfig: TriggerTelegramEventContentDTO;
  actionId?: string;
  enabled?: boolean;
}

export class TriggerTeamsEventContentDTO {
  endpoint: string;
  template: string;
  xdays: string;
}

export interface TriggerTeamsAction {
  type: TriggerActionTypeEnum.TEAMS_ACTION;
  stateful: false;
  teamsConfig: TriggerTeamsEventContentDTO;
  actionId?: string;
  enabled?: boolean;
}

export type AvailableActions = TriggerEmailAction | TriggerWebhookAction | TriggerTelegramAction | TriggerTeamsAction;
